import axios from '../../../../shared/axios';

import { AppDispatch } from '../../../../store';
import { NCRoamSubscriptionPlan, NCRoamAgencySubscription, NCRoamUser, NCRoamSubscribeResponse, NCRoamPageRequest } from '../../models';

import * as actionTypes from '../constants/actionTypes';

const getNCRoamSubscriptionPlansStart = () => {
  return {
    type: actionTypes.GET_NC_ROAM_SUBSCRIPTION_PLANS_START,
  };
};

const getNCRoamSubscriptionPlansSuccess = (data: NCRoamSubscriptionPlan[] | null) => {
  return {
    type: actionTypes.GET_NC_ROAM_SUBSCRIPTION_PLANS_SUCCESS,
    data: data,
  };
};

const getNCRoamSubscriptionPlansFail = (error: any) => {
  return {
    type: actionTypes.GET_NC_ROAM_SUBSCRIPTION_PLANS_FAIL,
    error: error,
  };
};

export const getNCRoamSubscriptionPlans = () => {
  return (dispatch: AppDispatch) => {
    dispatch(getNCRoamSubscriptionPlansStart());
    const url = `/nc-roam-subscription/get-nc-roam-subscription-plans`;

    axios
      .get(url)
      .then((response) => dispatch(getNCRoamSubscriptionPlansSuccess(response.data.data)))
      .catch((err) => dispatch(getNCRoamSubscriptionPlansFail(err)));
  };
};

const getNCRoamAgencySubscriptionStart = () => {
  return {
    type: actionTypes.GET_NC_ROAM_AGENCY_SUBSCRIPTION_START,
  };
};

const getNCRoamAgencySubscriptionSuccess = (data: NCRoamAgencySubscription | null) => {
  return {
    type: actionTypes.GET_NC_ROAM_AGENCY_SUBSCRIPTION_SUCCESS,
    data: data,
  };
};

const getNCRoamAgencySubscriptionFail = (error: any) => {
  return {
    type: actionTypes.GET_NC_ROAM_AGENCY_SUBSCRIPTION_FAIL,
    error: error,
  };
};

export const getNCRoamAgencySubscription = () => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getNCRoamAgencySubscriptionStart());
      const url = `/nc-roam-subscription/get-nc-roam-agency-subscription`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getNCRoamAgencySubscriptionSuccess(response.data.data));
          resolve(response.data.data);
        })
        .catch((err) => {
          dispatch(getNCRoamAgencySubscriptionFail(err));
          reject(err);
        });
    });
  };
};

const getNCRoamUsersStart = () => {
  return {
    type: actionTypes.GET_NC_ROAM_USERS_START,
  };
};

const getNCRoamUsersSuccess = (data: NCRoamUser[] | null) => {
  return {
    type: actionTypes.GET_NC_ROAM_USERS_SUCCESS,
    data,
  };
};

const getNCRoamUsersFail = (error: any) => {
  return {
    type: actionTypes.GET_NC_ROAM_USERS_FAIL,
    error: error,
  };
};

export const getNCRoamUsers = (pageRequest: NCRoamPageRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getNCRoamUsersStart());
      const url = `/nc-roam-subscription/get-nc-roam-users`;

      axios
        .post(url, { ...pageRequest })
        .then((response) => {
          dispatch(getNCRoamUsersSuccess(response.data.data));
          resolve(response.data.data);
        })
        .catch((err) => {
          dispatch(getNCRoamUsersFail(err));
          reject(err);
        });
    });
  };
};

const ncRoamSubscribeStart = () => {
  return {
    type: actionTypes.NC_ROAM_SUBSCRIBE_START,
  };
};

const ncRoamSubscribeSuccess = (data: NCRoamSubscribeResponse | null) => {
  return {
    type: actionTypes.NC_ROAM_SUBSCRIBE_SUCCESS,
    data,
  };
};

const ncRoamSubscribeFail = (error: any) => {
  return {
    type: actionTypes.NC_ROAM_SUBSCRIBE_FAIL,
    error: error,
  };
};

export const ncRoamSubscribe = (planId: string) => {
  return (dispatch: AppDispatch) => {
    return new Promise<NCRoamSubscribeResponse>((resolve, reject) => {
      dispatch(ncRoamSubscribeStart());
      const url = `/nc-roam-subscription/subscribe`;

      axios
        .post(url, { subscriptionPlanId: planId })
        .then((response) => {
          dispatch(ncRoamSubscribeSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(ncRoamSubscribeFail(err));
          reject(err);
        });
    });
  };
};

const ncRoamCancelSubscriptionStart = () => {
  return {
    type: actionTypes.NC_ROAM_CANCEL_SUBSCRIPTION_START,
  };
};

const ncRoamCancelSubscriptionSuccess = (data: boolean) => {
  return {
    type: actionTypes.NC_ROAM_CANCEL_SUBSCRIPTION_SUCCESS,
    data,
  };
};

const ncRoamCancelSubscriptionFail = (error: any) => {
  return {
    type: actionTypes.NC_ROAM_CANCEL_SUBSCRIPTION_FAIL,
    error: error,
  };
};

export const ncRoamCancelSubscription = () => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(ncRoamCancelSubscriptionStart());
      const url = `/nc-roam-subscription/cancel-subscription`;

      axios
        .post(url)
        .then((response) => {
          dispatch(ncRoamCancelSubscriptionSuccess(response.data.data));
          resolve(response.data.data);
        })
        .catch((err) => {
          dispatch(ncRoamCancelSubscriptionFail(err));
          reject(err);
        });
    });
  };
};

const ncRoamUpgradeSubscriptionStart = () => {
  return {
    type: actionTypes.NC_ROAM_UPGRADE_SUBSCRIPTION_START,
  };
};

const ncRoamUpgradeSubscriptionSuccess = (data: boolean) => {
  return {
    type: actionTypes.NC_ROAM_UPGRADE_SUBSCRIPTION_SUCCESS,
    data,
  };
};

const ncRoamUpgradeSubscriptionFail = (error: any) => {
  return {
    type: actionTypes.NC_ROAM_UPGRADE_SUBSCRIPTION_FAIL,
    error: error,
  };
};

export const ncRoamUpgradeSubscription = (planId: string) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(ncRoamUpgradeSubscriptionStart());
      const url = `/nc-roam-subscription/upgrade-subscription`;

      axios
        .post(url, { subscriptionPlanId: planId })
        .then((response) => {
          dispatch(ncRoamUpgradeSubscriptionSuccess(response.data.data));
          resolve(response.data.data);
        })
        .catch((err) => {
          dispatch(ncRoamUpgradeSubscriptionFail(err));
          reject(err);
        });
    });
  };
};
